module.exports = __webpack_public_path__ + "static/media/photo278.964ca87b.jpg";